import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Row, Col } from "reactstrap";

import { uploadScoreCard } from "../../actions/uploadScoreCardActions";
import { getLastScoreCard } from "../../actions/getLastScoreCardActions";
import { uploadCsvClients } from "../../actions/uploadCsvClientsActions";

import UploadScoreCardForm from "../../components/upload-score-card-form";
import UploadCsvClientsForm from "../../components/upload-csv-clients-form";
import {
  getLastScoreCardSelector,
  scoreCardsIsLoadingSelector,
} from "../../selectors";

import "./uploadScoreCardPage.css";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import useRoles from "../../../../components/hooks/useRoles";

const randomNum = Date.now();

const UploadScoreCardPage = () => {
  const [initialValues, setInitialValues] = useState({
    scFile: undefined,
    randomNum,
  });
  const [initialUploadCsvClientsValues, setInitialUploadCsvClientsValues] =
    useState({ csvFile: undefined, randomNum });

  const scoreCard = useSelector(getLastScoreCardSelector);
  const isLoading = useSelector(scoreCardsIsLoadingSelector);
  const dispatch = useDispatch();
  const { isCustomerSupport } = useRoles();

  useEffect(() => {
    dispatch(getLastScoreCard());
  }, []);

  const handleSubmit = (data) => {
    if (data.scFile) {
      dispatch(uploadScoreCard(data));
      setInitialValues({ scFile: "", randomNum: Date.now() });
    }
  };

  const handleUploadCsvClientsSubmit = (data) => {
    if (data.csvFile) {
      dispatch(uploadCsvClients(data));
      setInitialUploadCsvClientsValues({ csvFile: "", randomNum: Date.now() });
    }
  };

  return (
    <Container className="p-0 col-12">
      <PageTitle title="upload score card" className="mb-5" />
      <FullscreenLoader loading={isLoading} />
      <Row style={{ width: 800 }} className="justify-content-between ">
        <Col lg={6} className="p-0">
          <UploadScoreCardForm
            title="Upload score card"
            handleSubmit={handleSubmit}
            initialValues={initialValues}
          />
        </Col>
        <Col lg={6} className="p-0">
          <UploadCsvClientsForm
            disabled={isCustomerSupport}
            title="Upload Csv Clients"
            handleUploadCsvClientsSubmit={handleUploadCsvClientsSubmit}
            initialUploadCsvClientsValues={initialUploadCsvClientsValues}
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col className="center" lg={12}>
          Current Matrix:
        </Col>
      </Row>

      <Row>
        <Col className="center" lg={12}>
          {scoreCard != null &&
            scoreCard.data != null &&
            scoreCard.data.length > 0 && (
              <a
                className="link-score-card"
                target="_blank"
                href={scoreCard.data[0].filename}
              >
                {scoreCard.data[0].name} |{" "}
                {new Date(scoreCard.data[0].createDate).toLocaleString()} |{" "}
                {scoreCard.data[0].createdByName}
              </a>
            )}
        </Col>
      </Row>
    </Container>
  );
};

export default UploadScoreCardPage;



// WEBPACK FOOTER //
// ./src/features/score-card/pages/upload-score-card-page/UploadScoreCardPage.jsx